(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-thumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-thumbs')) {
    class CardThumbs extends HTMLElement {
      /** @type {HTMLElement | null} */
      #track = null;
      /** @type {ResizeObserver | null} */
      #observer = null;

      connectedCallback() {
        this.#track = this.querySelector('.card-thumbs__track');
        if (!this.#track) return;

        this.#track.addEventListener('scroll', this.#update, { passive: true });
        this.addEventListener('click', this.#handleClick);
        this.#observer = new ResizeObserver(this.#update);
        this.#observer.observe(this.#track);
        this.#update();
      }

      disconnectedCallback() {
        this.#track?.removeEventListener('scroll', this.#update);
        this.removeEventListener('click', this.#handleClick);
        this.#observer?.disconnect();
        this.#observer = null;
      }

      /** @param {MouseEvent} event */
      #handleClick = (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-direction]') : null;
        if (!(button instanceof HTMLButtonElement) || !this.#track) return;

        const direction = button.dataset.direction === 'next' ? 1 : -1;
        // ponytail: LTR only; flip `direction` with getComputedStyle(track).direction if an RTL locale ships
        this.#track.scrollBy({ left: direction * this.#track.clientWidth * 0.8, behavior: 'smooth' });
      };

      #update = () => {
        const track = this.#track;
        if (!track) return;

        const maxScroll = track.scrollWidth - track.clientWidth;
        this.toggleAttribute('overflowing', maxScroll > 1);

        for (const button of this.querySelectorAll('.card-thumbs__button')) {
          if (!(button instanceof HTMLButtonElement)) continue;
          button.disabled =
            button.dataset.direction === 'next' ? track.scrollLeft >= maxScroll - 1 : track.scrollLeft <= 1;
        }
      };
    }

    customElements.define('card-thumbs', CardThumbs);
  }
  } catch(e) { console.error(e); }
})();

})();
